import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { TimingUtils } from 'record-it-utils/utils/TimingUtils/TimingUtils';

/**
 * react-spring behaves really strange in tests without the reset option being set.
 * Without reset being set, you would have to call `waitForAnimation` before interacting with the rendered dom.
 * This makes it really error prone to test, since your tests can simply pass because you forgot to call this.
 * As a workaround, the `reset` option is set for a short time, so you don't have to call `waitForAnimation`.
 *
 * We can't set it permanentaly though because this will cause issues if the animation is reversed while it's running, because some callbacks won't be called.
 * This causes issues with the state then and no animations will be played.
 */
export function useSpringReset() {
  const $ = _c(2);
  const [reset, setReset] = useState(true);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const disposable = TimingUtils.setTimeout(() => {
        setReset(false);
      }, 0);
      return () => disposable.dispose();
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  return reset;
}